<template>
	<!-- 下方分页器 -->
	<div class="pagination" >
					<div class="block">
						<el-pagination
						@current-change="handleCurrentChange"
						:current-page="per_page"
						:page-sizes="pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total">
						</el-pagination>
					</div>
			</div>
</template>

<script>
	export default {
		props: {
		    total: {
		        type: Number,
		        default: 1
		    },
		    per_page: {
		        type: Number,
		        default: 1
		    },
			pageSize:{
		        type: Array,
		        default: [4]
		    }
		},
		data(){
			return{
				
			}
		},
		computed: {
			
		},
		methods: {
			handleCurrentChange(page) {
				
					this.$emit('handleCurrentChange', page);
				
			}
		}
	}
</script>

<style>
	/* .分页器 */
	.pagination{
				height: 48px;
				width: 648px;
				margin: 0 auto;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #C9010A;
			}
			.el-pagination .el-pager li:hover {
				color: #EE632B;
			}
			.el-pagination .el-pager li:not(.disabled):hover {
				color: #EE632B;
			}
			.el-pagination .el-pager li:not(.disabled).active {
			
				color: #EE632B;
			}
			.el-pagination .btn-prev:hover{
				
				color: #EE632B;
			}
			.el-pagination .btn-next:hover{
				color: #EE632B;
			}

			li.el-select-dropdown__item.selected{
				color: #EE632B!important;
			}

			.el-input__inner:hover{
				border-color:#EE632B !important;
			}
			.el-input__inner:focus{
				border-color:#EE632B !important;
			}
			
</style>
